(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["categories-popup"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cat-tab').forEach(function (tab) {
    tab.addEventListener('mouseenter', function () {
    const target = this.dataset.tab;

    document.querySelectorAll('.cat-tab').forEach(t => t.classList.remove('active'));
    document.querySelectorAll('.cat-content').forEach(c => c.classList.remove('active'));

    this.classList.add('active');
    document.querySelector('.cat-content[data-content="' + target + '"]').classList.add('active');
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["discover-popup"] && !Shopify.designMode) return;
  try {
    const searchInput = document.getElementById('brandSearch');
  searchInput.addEventListener('input', function () {
  const value = this.value.trim().toLowerCase();
  // BRAND CARDS
  document.querySelectorAll('.brand-card').forEach(card => {
    const brandName = card.dataset.brand?.toLowerCase() || '';

    if(value === '' || brandName.includes(value)) {
      card.style.visibility = 'visible';
      card.style.position = '';
      card.style.width = '';
      card.style.height = '';
      card.style.margin = '';
    } else {
      card.style.visibility = 'hidden';
      card.style.position = 'absolute';
      card.style.width = '0';
      card.style.height = '0';
      card.style.margin = '0';
    }
  });

  // LEFT LIST
  document.querySelectorAll('.brand-list li').forEach(item => {
    const text = item.textContent.trim().toLowerCase();
    item.style.display = value === '' || text.includes(value) ? '' : 'none';
  });
});
document.addEventListener('click', function(e){
  const card = e.target.closest('.brand-card');
  if(!card) return;
  const url = card.dataset.href;
  if(url && url !== '#'){
      window.location.href = url;
  }
});
  } catch(e) { console.error(e); }
})();

})();
